import { defineClient, websiteProxyUrl } from '@/services/api';

const endpoint = process.env.VUE_APP_WEBSITE_URL ;
const apiClient = defineClient();

export default {
    // Returns a same-origin URL that proxies to the website's curve JSON.
    getCurvePath(title) {
        return websiteProxyUrl(`/wp-content/themes/midopt/public/data/curve/${title}.min.json`);
    },
    // External link the user navigates to — kept absolute on purpose.
    getCurvePermalink(title) {
        return `${endpoint}/filters/${title.toLowerCase()}/`;
    },
    // Define the functions to get the curve path data with the API
    async getPathData(path) {
        return apiClient.get(path);
    },
};